<template>
    <transition-group name="list" v-if="required_fields">

        <div class="fields input" :class="{'has-error': errors.has('firstname') }" v-bind:key="0">
            <label for="firstname">{{ $parent.$parent.locale.text_child_first_name }}</label>
            <input type="text" @keyup.enter="submit" value="" placeholder="" name="firstname" id="firstname" v-validate="{ rules: { required: required_fields.first_name, max: 40} }" v-model="firstname"/>
            <transition name="slide-fade"><p class="text-danger" v-if="errors.has('firstname')">{{ errors.first('firstname') }}</p></transition>
        </div>

        <div class="fields input" :class="{'has-error': errors.has('lastname') }" v-bind:key="1">
            <label for="lastname">{{ $parent.$parent.locale.text_child_last_name }}</label>
            <input type="text" @keyup.enter="submit" value=""  placeholder="" name="lastname" id="lastname" v-validate="{ rules: { required: required_fields.last_name, max: 40} }" v-model="lastname"/>
            <transition name="slide-fade"><p class="text-danger" v-if="errors.has('lastname')">{{ errors.first('lastname') }}</p></transition>
        </div>

        <div class="fields input" :class="{'has-error': errors.has('dateofbirth') }" v-bind:key="5">
            <label>{{ $parent.$parent.locale.text_child_date_of_birth }}</label>
            <input type="hidden" id="dateofbirth" name="dateofbirth" v-model="dateofbirth" v-validate="{ rules: { required: required_fields.dob, valid_date: true, allowed_age: true} }"/>
        </div>
        <div class="fields input dob-date" :class="{'has-error': errors.has('dateofbirth') }" v-bind:key="2">
            <input type="number" @keyup.enter="submit" v-model="dob.date" v-mask="'##'" pattern="[0-9]" placeholder="Day" v-validate="{ rules: { required: true } }" name="dob_date"/>
        </div>
        <div class="fields dropdown dob-month quick-add" :class="{'has-error': errors.has('dateofbirth') }" v-bind:key="3">
            <div class="dropdown-inner">
                <select v-model="dob.month" @keyup.enter="submit" v-validate="{ rules: { required: true } }" name="dob_month">
                    <option value="" disabled selected>Month</option>
                    <option v-for="(month, key) in Date.getMonths()" :value="key">{{ month }}</option>
                </select>
                <i class="fa fa-chevron-down"></i>
            </div>
        </div>
        <div class="fields input dob-year" :class="{'has-error': errors.has('dateofbirth') }" v-bind:key="4">
            <input type="number" @keyup.enter="submit" pattern="[0-9]" v-model="dob.year" v-mask="'####'" placeholder="Year" v-validate="{ rules: { required: true,  } }" name="dob_year"/>
        </div>
        <div class="fields input" key="doberror">
            <transition name="slide-fade"><p class="text-danger" v-if="errors.has('dateofbirth')">{{ errors.first('dateofbirth') }}</p></transition>
        </div>

        <div class="fields input" v-bind:key="6">
            <a @click="submit" class="cta-button blue">Add Child</a>
        </div>
    </transition-group>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';

    export default {
        props: ['selection'],
        data () {
            return {
                firstname: "",
                lastname: "",
                dob: {
                    date: "",
                    month: "",
                    year: "",
                },

                submitted: false,
                required_fields: undefined,
            }
        },
        watch: {
            'dob': {
                handler: _.debounce(
                    function () {
                        if(!this.submitted)
                            this.$validator.validate('dateofbirth', this.dateofbirth);
                    },
                    2000
                ),
                deep: true
            },
        },
        computed: {
            dateofbirth: function () {
                var array = Object.keys(this.dob).map(key => {
                    return this.dob[key];
                });
                return array.join('/');
            }
        },
        components: {
            Datepicker
        },
        methods: {

            submit: _.debounce(
                function() {
                    /**
                     * Obviously don't want to continue if there are errors.
                     */
                    this.$validator.validateAll();

                    if(this.errors.errors.length) {
                        return false;
                    }

                    var dateofbirth = this.dateofbirth.toString().toDate();

                    var participant = {
                        user_id: (this.$root.auth ? this.$root.auth.user_id : null),
                        first_name: this.firstname,
                        last_name: this.lastname,
                        dob: dateofbirth.toShortDateString(true),
                    };
                    axios.post('/camp-booking/participants', participant)
                        .then(response => {
                            //Emitting the event to the parent vue to update the list of available participants
                            this.$emit('newparticipant', response.data.data.participant_id, participant);

                            //Resetting the participant inputs to blank for new entry if wanted
                            this.firstname = this.lastname = this.dob.date = this.dob.month = this.dob.year = "";
                            this.submitted = true;
                            setTimeout(() => { this.errors.clear(); }, 250);
                            setTimeout(() => { this.submitted = false }, 2300);
                        });
                },
                500
            )
        },
        created () {
            axios.get('/camp-booking/participants/required-fields')
                .then(response => {
                    this.required_fields = response.data.data;
                });
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// NewParticipant.vue?785d2feb